import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/common/Select';
import { cn } from '@/utils/utils';
import React from 'react';
import { useTranslation } from 'react-i18next';

// Use when used in Modal and Combobox cannot be selected

interface SelectBoxItem {
    label: string,
    value: string
}

interface SelectBoxProps extends React.InputHTMLAttributes<HTMLInputElement> {
    items?: SelectBoxItem[],
    defaultValue?: string,
    onSelected: (item: SelectBoxItem) => void
}

const SelectBox = React.forwardRef<HTMLButtonElement, SelectBoxProps>(
    ({ items, defaultValue, onSelected, className, ...props }, ref) => {
        // hook
        const { t } = useTranslation();
        return (
            <Select
                value={defaultValue}
                onValueChange={(value: string) => {
                    const item = items?.find((e: SelectBoxItem) => e.value === value);
                    if (item != null) {
                        onSelected(item);
                    }
                }}
            >
                <SelectTrigger
                    ref={ref}
                    className={cn(props.value, `${defaultValue ?? 'text-text-1'} truncate ${className}`)}
                >
                    <SelectValue placeholder={t('placeholder.select')}>
                    </SelectValue>
                </SelectTrigger>
                <SelectContent>
                    {
                        items?.map(item => (
                            <SelectItem key={item.value} value={item.value.toString()}>
                                {t(item.label)}
                            </SelectItem>
                        ))
                    }
                </SelectContent>
            </Select>
        );
    }
);
SelectBox.displayName = 'SelectBox';

export { SelectBox };
